// /opt/isp_erp/frontend/src/pages/warehouse/PendientesPage.jsx
import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { cargarContextoBodega } from "../../utils/contextoBodega";
import PendientesCentral from "./Pendientes";
import PendientesSucursalPanel from "../../components/warehouse/PendientesSucursalPanel";

/** Encargado de sucursal: solo ve los pendientes de su sucursal. Central y administrador: la pantalla de siempre
 *  y, encima, los pendientes de las sucursales si los hay. */
export default function PendientesPage() {
  const [ctx, setCtx] = useState(undefined);

  useEffect(() => {
    let vivo = true;
    cargarContextoBodega().then((c) => { if (vivo) setCtx(c || { central: true, sucursales: [] }); });
    return () => { vivo = false; };
  }, []);

  if (ctx === undefined) return (<Box sx={{ p: 6, textAlign: "center" }}><CircularProgress /></Box>);
  if (ctx.central === false) return <PendientesSucursalPanel ctx={ctx} />;
  return (
    <>
      {(ctx.sucursales || []).length > 0 && <PendientesSucursalPanel ctx={ctx} />}
      <PendientesCentral />
    </>
  );
}
